import React, { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import { AiFillPlayCircle } from "react-icons/ai";
import NoImg from "./NoImg.jpg";
import { useContext } from "react";
import { container } from "./NavBar";
import { AiOutlineClose } from "react-icons/ai";
import "../Styles/video.css";
import { Fragment } from "react";
import TrailerTvShows from "../Trailers/TrailerTvShows";

function TvShows() {

  const [showData, setShowData] = useState([]);
  const [title, setTitle] = useState("");
  const { toggle, inputValue } = useContext(container);
  const input = inputValue
  const shown = input ? "search" : "discover";
  const [trailer, setTrailer] = useState(true);

  const Api = `https://api.themoviedb.org/3//${shown}/tv`;
  const Images = "https://image.tmdb.org/t/p/w500/";

  const TvShows = async () => {
    const data = await axios.get(Api, {
      params: {
        api_key: "f14fc28bd5ca473908ddb62bd3f18aff",
        query: input
      },
    });
    const results = data.data.results;
    setShowData(results);
  };

  useEffect(() => {
    setTimeout(() =>{
      TvShows();
    },100)
  }, [input]);
  console.log(showData);

  const TvShowsTitle = (shows) => {
    setTitle(shows.name);
    setTrailer(!trailer);
  };

  return (
    <>
      <div className={toggle ? "mainBgColor" : "secondaryBgColor"}>
        <div className="movies-container">
          {showData.map((shows) => {
            return (
              <Fragment key={shows.id}>
                <div id={trailer ? "container" : "NoContainer"}>
                  <AiFillPlayCircle
                    color="#fff"
                    fontSize={40}
                    id={trailer ? "playIcon" : "hide"}
                    onClick={() => TvShowsTitle(shows)}
                  />
                  <img
                    src={
                      shows.poster_path
                        ? `${Images}${shows.poster_path}`
                        : NoImg
                    }
                    alt=""
                    onClick={() => TvShowsTitle(shows)}
                  />
                  <h3
                    id={shows.name.length > 20 ? "smaller-Text" : ""}
                    className={toggle ? "maincolor" : "secondaryColor"}
                  >
                    {shows.name}
                  </h3>
                </div>
              </Fragment>
            );
          })}
          {trailer ? console.log : <TrailerTvShows TvShowsTitle={title} toggle={toggle}/>}
          <AiOutlineClose
            id={trailer ? "Nothing" : "Exit1"}
            className={toggle ? "DarkTheme" : "LightThemeClose"}
            fontSize={55}
            color="#fff"
            cursor={"pointer"}
            onClick={() => setTrailer(true)}
          />
        </div>
      </div>
    </>
  );
}
export default TvShows;


